/**
 * Эвристика: ошибка после деплоя / пересборки (устаревшие чанки, недоступный _next/static).
 *
 * P0-F5: не путать network/SW/offline/502–504 с деплоем — иначе витрина уходит
 * в «Обновляем платформу» и маскирует медленный catalog (Stress Audit 2026-08-11).
 *
 * @param {unknown} error
 * @returns {boolean}
 */
export function isLikelyDeployError(error) {
  if (!error) return false;

  const name = String(error?.name || '');
  const message = String(error?.message || '').toLowerCase();

  if (name === 'ChunkLoadError') return true;

  const hasChunkSignal =
    message.includes('chunk') ||
    message.includes('_next/static') ||
    message.includes('dynamically imported') ||
    message.includes('importing a module script');

  // Network / edge / SW — не deploy, если нет явного сигнала чанка/модуля.
  const nonDeploy = [
    'failed to fetch',
    'networkerror',
    'network request failed',
    'load failed',
    'offline',
    ' 503',
    '503 ',
    ' 502',
    '502 ',
    ' 504',
    '504 ',
    'timeout',
    'timed out',
    'aborted',
    'the operation was aborted',
    'err_network',
    'err_internet_disconnected',
  ];
  if (!hasChunkSignal && nonDeploy.some((pattern) => message.includes(pattern))) {
    return false;
  }

  const deployPatterns = [
    'loading chunk',
    'loading css chunk',
    'failed to fetch dynamically imported module',
    'dynamically imported module',
    'importing a module script failed',
    'error loading dynamically imported module',
    'failed to load script',
    '_next/static',
  ];

  if (deployPatterns.some((pattern) => message.includes(pattern))) return true;

  // «Unexpected token» сам по себе часто = HTML/JSON от 502/503/offline, не битый chunk.
  if (message.includes('unexpected token')) {
    return hasChunkSignal || message.includes('script') || message.includes('module');
  }

  return false;
}
